import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import { Location } from '@angular/common';
import * as moment from 'moment-timezone';
import { NrmService } from '../../_services/nrm.service';
import { PermitsService } from '../services/permits.service'
import { UtilService } from '../../_services/util.service';
import { WindowRef } from '../../_services/native-window.service';
import { environment } from '../../../environments/environment'

export enum PermitSteps {
  ChooseForest = 0,
  PermitInformation,
  RulesAgreement,
  PurchasePermit,
  Payment,
  PurchaseConfirmation
}
@Component({
    selector: 'app-order-confirmation',
    templateUrl: './order-confirmation.component.html',
    styleUrls: ['./order-confirmation.component.scss'],
    standalone: false
})
export class OrderConfirmationComponent implements OnInit {
  forest: any;
  permit: any;
  apiErrors: any;
  jwtToken: string;
  showCancelAlert = false;
  nativeWindow: any;
  permitSteps = PermitSteps;
  permitStepLabels = ['Choose Forest', 'Permit Information', 'Rules & Agreement', 'Purchase Permit', 'Payment', 'Purchase Confirmation'];
  currentStepIndex = this.permitSteps.PurchaseConfirmation;
  permitInfoUrl = '';
  isLoading = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private titleService: Title,
    public nrmService: NrmService,
    public permitsService: PermitsService,
    public util: UtilService,
    private winRef: WindowRef,
    private meta: Meta
  ) {
    this.nativeWindow = winRef.getNativeWindow();
    this.meta.addTag({
      name: 'description',
      content: `Permit`
    });
  }

  /**
   * Get data from route resolver
   */
  ngOnInit() {
    this.winRef.getNativeWindow().location.hash = ''; // clear out the hash on reload

    let isCancel = false;
    this.route.queryParams.forEach((params: Params) => {
      if (params.cancel) {
        isCancel = true;
      }

      if (params.t) {
        this.jwtToken = params.t;
      }
    });

    this.route.data.subscribe(data => {
      if (data.forest) {
        this.forest = data.forest;
      }
      if (data.permit) {
        this.permit = data.permit;
        this.permit.forest = this.forest;
        if (this.permit.status === 'Completed') {
          this.loadPermits();
          this.isLoading = false;
        } 
        else {
          // e-mail the permit to the purchaser
          this.permitsService.updatePermit(data.permit.permitId, 'Completed', this.jwtToken).subscribe({
            next: () => {
              this.permitsService.emailPDFbyId(data.permit.permitId).subscribe(() => {
                console.log('permit.pdf emailed');
              });
              this.loadPermits();
              this.isLoading = false;
            }, error: (err) => {
              console.log(err);
              this.router.navigate([`forests/${this.forest.code}/products/${this.permit.product}/permits/${this.permit.permitId}/paygov-error`])
              this.isLoading = false;
            }
          });
        }
      }
    });
  }

  loadPermits() {
    this.permitInfoUrl = `${window.location.origin}/forests/${this.permit.forest.code}/products/${this.permit.product}/#whereCanIHarvest`;
  }

  getFriendlyDate(date) {
    const friendlyDate = new Date(date);
    const month = friendlyDate.getMonth();
    const day = friendlyDate.getDay();
    const year = friendlyDate.getFullYear();

    return ' ' + month + '/' + day + '/' + year;
  }

  downloadPermit = () => {
    fetch(environment.apiUrl + 'permits/permit-pdf/' + this.permit.permitId, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      }
    })
    .then(res => {
      return res.arrayBuffer();
    })
    .then(res => {
      const blob = new Blob([res], { type: "application/pdf" })
      var url = window.URL || window.webkitURL;
      var link = url.createObjectURL(blob);
      var a = document.createElement("a");
      a.setAttribute("download", "permit.pdf");
      a.setAttribute("href", link);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    })
  }

  downloadLoadTags = () => {
    fetch(environment.apiUrl + 'permits/load-tags-pdf/' + this.permit.permitId, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      }
    })
    .then(res => {
      return res.arrayBuffer();
    })
    .then(res => {
      const blob = new Blob([res], { type: "application/pdf" })
      var url = window.URL || window.webkitURL;
      var link = url.createObjectURL(blob);
      var a = document.createElement("a");
      a.setAttribute("download", "load-tags.pdf");
      a.setAttribute("href", link);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    })
  }
}
